import { useEffect, useState } from "react";
import { Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import { IApplicabilityLevelProps } from "../FrontPageInterfaces";
import "./css/ApplicabilityLevel.css";
import "../../../common/CommonStyle.css";
export default function ApplicabilityLevel({
  isSelectedCompany,
  onSelect,
  onSerialNumberChange,
}: IApplicabilityLevelProps) {
  const [selectedRadio, setSelectedRadio] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const hide = process.env.REACT_APP_HIDE === "true";
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const id = event.target.id;
    setSelectedRadio(id);
    onSelect(id);
    onSerialNumberChange(serialNumber, false);
  };

  const handleSerialNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSerialNumber(event.target.value);
    onSerialNumberChange(serialNumber, false);
  };

  const handleSubmit = () => {
    if (serialNumber.length > 0) {
      onSerialNumberChange(serialNumber, true);
    }
  };

  useEffect(() => {
    if (!isSelectedCompany) setSelectedRadio("");
  }, [isSelectedCompany]);

  if (!isSelectedCompany) {
    return <></>;
  }

  return (
    <>
      <label>Applicability Level</label>
      <Form>
        {[
          { id: "product-range", label: "Product Range" },
          { id: "model", label: "Model" },
        ].map(({ id, label }) => (
          <Form.Check
            id={id}
            key={id}
            type="radio"
            label={label}
            checked={selectedRadio === id}
            onChange={handleRadioChange}
            className="form-check"
          />
        ))}
        {!hide && (
          <>
            <Form.Check
              id="product-number"
              key="product-number"
              type="radio"
              label="Product Number"
              checked={selectedRadio === "product-number"}
              onChange={handleRadioChange}
              className="form-check"
            />
            <Row>
              <Col xs={4}>
                <Form.Check
                  id="serial-number"
                  key="serial-number"
                  type="radio"
                  label="Serial Number"
                  checked={selectedRadio === "serial-number"}
                  onChange={handleRadioChange}
                  className="form-check"
                />
              </Col>
              {selectedRadio === "serial-number" && (
                <>
                  <Col xs={5}>
                    <InputGroup className="top-padding">
                      <Form.Control
                        id="input-serial-number"
                        placeholder="Enter Serial Number"
                        value={serialNumber}
                        onChange={handleSerialNumberChange}
                      />
                    </InputGroup>
                  </Col>
                  <Col xs={2}>
                    <Button className="top-padding" onClick={handleSubmit}>
                      Search
                    </Button>
                  </Col>
                </>
              )}{" "}
            </Row>
          </>
        )}
      </Form>
    </>
  );
}
